import React, { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Preloader from "../components/Preloader";
import { useLocation } from "react-router-dom";
import StickyCtas from "../components/StickyCTAs";
import Seo from "../components/Seo";

import Home from "../pages/home";
import Online from "../pages/online";
import Contact from "../pages/contact";
import Enquire from "../pages/enquire";
import PrivacyPolicy from "../pages/privacy";
import TermsConditions from "../pages/terms";

import AboutNagarjuna from "../pages/about/AboutNagarjuna";
import Careers from "../pages/careers";
import IIC from "../pages/iic";
import IdeaLab from "../pages/idealab";
import Error from "../pages/404";
import LoadTop from "../components/ScrollTop/LoadTop";
import ScrollToTop from "../components/ScrollTop";
// Routes brought in from main
import Gallery from "../pages/footer/gallery";
import AdmissionProcess from "../pages/study/admissions/AdmissionProcess";
import Hostel from "../pages/students/facilities/hostel";
import Examination from "../pages/Examination";

//websites


// footerpage




import Iqac from "../pages/Iqac";

// students ---> Facilities


// students ---> Business
import ApprovalsDisclosure from "../pages/approvals/ApprovalsDisclosure";
import MonthlyReports from "../pages/monthly-reports/MonthlyReports";
import AuditReports from "../pages/audit-reports/AuditReports";




// Engineering
import DepartmentDetails from "../pages/DepartmentDetails";
import Departments from "../pages/Departments";

// Sciences
import DepartmentMathematics from "../pages/DepartmentMathematics";
import DepartmentPhysics from "../pages/DepartmentPhysics";
import DepartmentChemistry from "../pages/DepartmentChemistry";
import DepartmentSocialScience from "../pages/DepartmentSocialScience";

// Pharmacy

// Eng common pages
import FacilitiesLabs from "../pages/students/academics/commonpages/facilities-labs";
import FacilitiesClass from "../pages/students/academics/commonpages/facilities-classrooms";
import ResearchProjectsDetails from "../pages/students/academics/commonpages/research-projects-details";
import ResearchPublicationsDetails from "../pages/students/academics/commonpages/research-publications-details";
import ResearchPatentsDetails from "../pages/students/academics/commonpages/research-patents-details";
import MinutesofMeeting from "../pages/students/academics/commonpages/minutes-of-meeting";
import Members from "../pages/students/academics/commonpages/members";
import Newsletter from "../pages/students/academics/commonpages/newsletter";
import AlumniConnect from "../pages/students/academics/commonpages/alumni-connect";
import Samashti from "../pages/Samashti";
import AutonomousRegulations from "../pages/AutonomousRegulations";
import NCC from "../pages/NCC";
import NBAVisitData from "../pages/NBAVisitData";


import OpportunitiesPlacements from "../pages/students/opportunities/opportunities-placements";
import ContactUs from "../pages/students/opportunities/contact-us";
// students close

// our research

import ResearchPage from "../pages/research/index";
import NISPPolicy from "../pages/NISPPolicy";
import Placements from "../pages/Placements";



import AqarReports from "../pages/about/credentials/IQAC/AqarReports";
import ExtendedProfile from "../pages/about/credentials/IQAC/ExtendedProfile";
import ImportantCriteria from "../pages/about/credentials/IQAC/ImportantCriteria";
import Nirf from "../pages/about/credentials/IQAC/Nirf";
import Alumni from "../pages/about/credentials/IQAC/Alumni";
import Yuvothsava from "../pages/Yuvothsava";






import Blog from "../pages/Blog/index";
import BlogDetails from "../pages/BlogDetails/index";
import Harshavardhini from "../pages/harshavardhini/index";
import PgcetLanding from "../pages/PgcetLanding/index";


// About Close

const App = () => {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Simulate data loading delay
    setTimeout(() => {
      setIsLoading(false);
    }, 300);
  }, []);
 

  return (
    <div className="App">
      {isLoading ? <Preloader /> : ""}
      <>
        <Seo />
        <LoadTop />
        <Routes>
          <Route path="/" exact element={<Home />} />
          {/* <Route path="/online" exact element={<Online />} /> */}
          <Route path="/about-nagarjuna" exact element={<AboutNagarjuna />} />
          <Route path="/research" exact element={<ResearchPage />} />

          <Route path="/contact" element={<Contact />} />
          <Route path="/enquire" element={<Enquire />} />
          <Route path="/privacy-policy" exact element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" exact element={<TermsConditions />} />
          <Route path="/gallery" exact element={<Gallery />} />
          <Route path="/admission-process" exact element={<AdmissionProcess />} />
          <Route path="/hostel" exact element={<Hostel />} />
          <Route path="/hostels" exact element={<Hostel />} />
          <Route path="/placements" exact element={<Placements />} />
          <Route path="/nisp-policy" exact element={<NISPPolicy />} />
          <Route path="/examination" exact element={<Examination />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/iic" element={<IIC />} />
          <Route path="/idealab" element={<IdeaLab />} />
                      <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogDetails />} />
            <Route path="/under-construction" element={<Error mode="construction" />} />
            <Route path="*" element={<Error />} />

          <Route path="/iqac" exact element={<Iqac />} />

      
    
    
          <Route path="/approvals-and-disclosure" exact element={<ApprovalsDisclosure />} />
          <Route path="/monthly-reports" exact element={<MonthlyReports />} />
          <Route path="/audit-reports" exact element={<AuditReports />} />

          <Route path="/departments" exact element={<Departments />} />
          <Route path="/department/:id" exact element={<DepartmentDetails />} />
          <Route path="/department/:id/:tab" exact element={<DepartmentDetails />} />

          {/* Engineering COMMON PAGES */}
          <Route
            path="/facilities-labs/:parameterId"
            exact
            element={<FacilitiesLabs />}
          />
          <Route
            path="/facilities-classrooms/:parameterId"
            exact
            element={<FacilitiesClass />}
          />
          <Route
            path="/research-projects/:parameterId"
            exact
            element={<ResearchProjectsDetails />}
          />
          <Route
            path="/research-publications/:parameterId"
            exact
            element={<ResearchPublicationsDetails />}
          />
          <Route
            path="/research-patents/:parameterId"
            exact
            element={<ResearchPatentsDetails />}
          />
          <Route
            path="/minutes-of-meeting/:parameterId"
            exact
            element={<MinutesofMeeting />}
          />
          <Route path="/members/:parameterId" exact element={<Members />} />
          <Route
            path="/newsletter/:parameterId"
            exact
            element={<Newsletter />}
          />
          <Route
            path="/alumni-connect/:parameterId"
            exact
            element={<AlumniConnect />}
          />
          <Route path="/samashti" element={<Samashti />} />
          <Route path="/autonomous-regulations" element={<AutonomousRegulations />} />
          <Route path="/ncc" element={<NCC />} />
          <Route path="/nba-visit-data" element={<NBAVisitData />} />


          <Route
            path="opportunities-placements"
            exact
            element={<OpportunitiesPlacements />}
          />
        
          <Route path="/contact-us" exact element={<ContactUs />} />


          <Route path="/iqac/annual-quality-assurance-reports" exact element={<AqarReports />} />
          <Route path="/iqac/extended-profile-of-the-institute" exact element={<ExtendedProfile />} />
          <Route path="/iqac/important-criteria" exact element={<ImportantCriteria />} />
          <Route path="/nirf" exact element={<Nirf />} />
          <Route path="/alumni" exact element={<Alumni />} />
          <Route path="/harshavardhini" exact element={<Harshavardhini />} />
          <Route path="/pgcet-landing" exact element={<PgcetLanding />} />
          <Route path="/yuvothsava" exact element={<Yuvothsava />} />

          {/* about close*/}
        </Routes>
        <StickyCtas />
        <ScrollToTop />{/* global back-to-top — shows on every page after scrolling */}
        <div
          className="npf_ai_agents"
          data-w="88d5ee5ae8ea4e5580625248f3156120"
          style={{ display: "none" }}
        ></div>
      </>
    </div>
  );
};

export default App;
